module.exports = __webpack_public_path__ + "img/workwear.bf6bfc0f.jpg";